const form_validation = require('./form_validation')

require('./form')

$(function() {

  const $form = $('#reset_password_new_user')

  $form.on('submit', function(event){
    if(!$form.find('#reset_password_user_email').val().length){
      event.preventDefault()
      event.stopPropagation()
    }
  })

  function on_success () {
    $form.find('button').hide()
    $form.find('input[type=email]').attr('disabled', 'disabled')
    $form.find('.success-message').show()
  }

  $form.on('ajax:success', on_success)
  $form.on('ajax:before', form_validation.show_loader)
  $form.on('ajax:complete', form_validation.hide_loader)
})